import {McbGridColumnType} from "./enum/mcb-grid-column-type";
import {McbGridColumnAlign} from "./enum/mcb-grid-column-align"

export class McbGridColumn {
  field?: string;
  title: string;
  align?: McbGridColumnAlign;
  type?: McbGridColumnType;
  locked?: boolean;
  sortable?: boolean;
  width?: number = 200;
}
